import React from "react";
import {
  getCustomerPreviewValues,
  normalizeAmountValue,
  replaceTokens,
} from "@utils";
import { useUser } from "@auth";
import { useMerchant } from "@auth";
import { assetBaseUrl } from "@api";

const RequestSmsPreview = ({
  message,
  completeMessage,
  amount = 1234.45,
  overrideAmountToken = false,
}) => {
  const { user } = useUser();
  const { merchant } = useMerchant();

  const messageText = message || "";

  const normalizedAmount = normalizeAmountValue(amount);

  const previewValues = overrideAmountToken
    ? [
        ...getCustomerPreviewValues().filter((x) => x.token !== "amount_requested"),
        { token: "amount_requested", value: normalizedAmount },
      ]
    : getCustomerPreviewValues();

  const displayMessage =
    completeMessage ||
    (messageText ? replaceTokens(previewValues, messageText) : "");

  return (
    <div className="bg-white h-full rounded-2xl py-5 px-2.5 shadow-lg w-96">
      <p className="text-sm text-zinc-500 text-center">Text Message - SMS</p>
      <p className="text-sm text-zinc-500 text-center">Today 10:30</p>
      <p className="bg-zinc-200 rounded-lg py-1.5 px-3 w-[255px] my-4">
        {displayMessage}
        <br />
        https://webpay.ontik.io/pay/id
      </p>
      <div className="rounded-lg w-[285px] bg-zinc-200">
        <img
          className="bg-zinc-50"
          src={`${assetBaseUrl()}${merchant?.organisationId}-og.png`}
        />
        <p className="px-3 pt-3 font-medium">
          You are requested to pay {merchant?.name || "us"} {normalizedAmount}
        </p>
        <p className="px-3 pb-3">wepay.ontik.io</p>
      </div>
    </div>
  );
};

export default RequestSmsPreview;
